module.exports = __webpack_public_path__ + "img/zhihuishequ.c23dbf4d.png";